// ----------------------------------------------------------------------

export function remToPx(value) {
    return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value) {
    return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }) {
    return {
        '@media (min-width:600px)': {
            fontSize: pxToRem(sm),
        },
        '@media (min-width:900px)': {
            fontSize: pxToRem(md),
        },
        '@media (min-width:1200px)': {
            fontSize: pxToRem(lg),
        },
    };
}

// ----------------------------------------------------------------------

const FONT_PRIMARY = 'Public Sans, sans-serif'; // Google Font
// const FONT_SECONDARY = 'CircularStd, sans-serif'; // Local Font

const typography = {
    fontFamily: FONT_PRIMARY,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    h1: {
        fontWeight: 700,
        lineHeight: 1.25,
        fontSize: pxToRem(32),
        ...responsiveFontSizes({ sm: 34, md: 36, lg: 36 }),
    },
    h2: {
        fontWeight: 700,
        lineHeight: 1.3,
        fontSize: pxToRem(26),
        ...responsiveFontSizes({ sm: 28, md: 30, lg: 30 }),
    },
    h3: {
        fontWeight: 700,
        lineHeight: 1.4,
        fontSize: pxToRem(22),
        ...responsiveFontSizes({ sm: 22, md: 24, lg: 24 }),
    },
    h4: {
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(20),
        ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
    },
    h5: {
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(18),
        ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
    },
    h6: {
        fontWeight: 700,
        lineHeight: 28 / 18,
        fontSize: pxToRem(17),
        ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
    },
    subtitle1: {
        fontWeight: 600,
        lineHeight: 1.5,
        fontSize: pxToRem(16),
    },
    subtitle2: {
        fontWeight: 600,
        lineHeight: 22 / 14,
        fontSize: pxToRem(14),
    },
    body1: {
        lineHeight: 1.5,
        fontSize: pxToRem(16),
    },
    body2: {
        lineHeight: 22 / 14,
        fontSize: pxToRem(14),
    },
    caption: {
        lineHeight: 1.5,
        fontSize: pxToRem(12),
    },
    overline: {
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(12),
        textTransform: 'uppercase',
    },
    button: {
        fontWeight: 700,
        lineHeight: 24 / 14,
        fontSize: pxToRem(14),
        // Not 'capitalize': labels come from i18n already cased, and the
        // transform mangles them ("Clear and close" -> "Clear And Close",
        // and every word in ru).
        textTransform: 'none',
    },
    // Grid-toolbar controls (Filter by, segments, Actions, New): the button
    // face at line-height 1, so a 44px control centres it exactly.
    toolbarButton: {
        fontWeight: 700,
        lineHeight: 1,
        fontSize: pxToRem(14),
        textTransform: 'none',
    },
    // Status Label text. 11px rather than Base's 12: the Label sets the floor
    // of a compact grid row, and at 12px it was nearly as tall as the row.
    label: {
        fontWeight: 700,
        lineHeight: 1,
        fontSize: pxToRem(11),
    },
};

export default typography;
